<template>
    <v-card
      class="alert-card pa-2 pl-3"
      style="display: inline-block; width:100%; min-height: 205px;"
    >

      <div>
      <!-- <div style="height:45px;"> -->
        <v-row class="mx-0" justify="space-between">
          <div style="font-size:15px;" >
            <i class="mr-1 mt-1 icon-price-guard-21x25 primary--text"></i>
            <p class="mb-0 d-inline-flex">{{ card.identity }}&nbsp;:&nbsp;</p>
            <p class="mb-0 d-inline-flex">{{ card.symbol }}</p>
          </div>
        </v-row>
        <v-row>
          <v-col cols="4" class="pg-card-text pr-0 pb-0">
            <p>Insert Time :</p>
            <p>Status :</p>
            <p>Timestamp :</p>
            <p>Date time :</p>
            <p>Expires in :</p>
            <div v-if="card.showMore">
              <p>Bid :</p>
              <p>Ask :</p>
              <p>Spread :</p>
              <p>Digits :</p>
            </div>
          </v-col>
          <v-col cols="8" class="pg-card-text px-0 pb-0">
            <p class="title-color">{{card.insertTime}}</p>
            <p>{{card.status}}</p>
            <p class="title-color">{{card.timestampInMillis}}</p>
            <p class="title-color">{{card.datetime}}</p>
            <p class="title-color">{{card.expires_at}}</p>
            <div v-if="card.showMore">
              <p>{{card.bid}}</p>
              <p>{{card.ask}}</p>
              <p>{{card.spread}}</p>
              <p>{{card.digits}}</p>
            </div>

          </v-col>
        </v-row>
        <v-btn @click="card.showMore ? $emit('show-less') : $emit('show-more')" text small class="px-1 mt-1 remove-btn-text-transform" style="margin-left: -6px;">
          <v-icon small color="primary">{{card.showMore ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'}}</v-icon><p class="ml-1 mb-0" style="font-size: 14px;margin-top: 1px;">{{card.showMore ? 'Show less' : 'Show more'}}</p>
        </v-btn>
      </div>

    </v-card>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
  }),
  methods: {

  },
  computed: {}
};
</script>
<style>
.pg-card-text p {
  margin-bottom: 0px !important;
  font-size: 14px;
}
.pg-card-text p.title-color {
  color: rgb(160, 160, 0);
}
</style>